import { BaseService } from "core/services";
import { FacilityInventoryCountDetailRouteService } from "application/facility-inventory/services";

class FacilityInventoryCountDetailService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FacilityInventoryCountDetailRouteService());
	}

	async getExisting(facilityInventoryCountHeaderId, productId){
        const url = this.routeService.getExisting(facilityInventoryCountHeaderId, productId);
        const response = await this.apiClient.get(url);
        return response.data;
    }
    
    async createFacilityInventoryCountDetails(resource){
        const url = this.routeService.createFacilityInventoryCountDetails(resource);
        const response = await this.apiClient.post(url, resource);
        return response.data;
    }

    async updateFacilityInventoryCountDetails(facilityInventoryCountHeaderId){
        const url = this.routeService.updateFacilityInventoryCountDetails(facilityInventoryCountHeaderId);
        return this.apiClient.put(url);
    }

    async updateNikoFacilityInventoryCountDetails(facilityInventoryCountHeaderId){
        const url = this.routeService.updateNikoFacilityInventoryCountDetails(facilityInventoryCountHeaderId);
        return this.apiClient.put(url);
    }

    getDownloadUrl(filter) {
        return this.apiClient.appOptions.apiUrl + this.routeService.download(filter);
    }

    getDownloadInventoryDetailUrl(filter) {
        return this.apiClient.appOptions.apiUrl + this.routeService.downloadInventoryDetail(filter);
    }

    async convert(facilityInventoryCountHeaderId){ 
        const url = this.routeService.convert(facilityInventoryCountHeaderId);
        const response = await this.apiClient.put(url);
        return response.data;
    }

    async updateQuantity(resource) {
        const url = this.routeService.updateQuantity(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    getNewDownloadInventoryDetailUrl(filter) {
        return this.apiClient.appOptions.apiUrl + this.routeService.newDownloadInventoryDetail(filter);
    }

    getDownloadInventoryReportUrl(filter) {
        return this.apiClient.appOptions.apiUrl + this.routeService.downloadInventoryReport(filter);
    }

    getDownloadNikoInventoryReportUrl(filter) {
        return this.apiClient.appOptions.apiUrl + this.routeService.downloadNikoInventoryReport(filter);
    }

    async downloadInventoryDetail(filter) {
        return this.routeService.downloadInventoryReportBytes(filter);
    }    
    
    async downloadNikoInventoryDetail(filter) {
        return this.routeService.downloadNikoInventoryReportBytes(filter);
    }           
}

export default FacilityInventoryCountDetailService;